import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ServiceAreas from '../components/ServiceAreas';

const ServiceAreasPage = () => (
  <div className="min-h-screen bg-white" data-testid="service-areas-page">
    <Helmet>
      <title>Service Areas — RO Repair & Installation Across Jaipur, Darbhanga | RO Dekho</title>
      <meta
        name="description"
        content="See every neighbourhood RO Dekho serves. Same-day RO installation, repair, AMC and filter replacement in 65+ Jaipur localities and Darbhanga. Tap your area to book."
      />
      <link rel="canonical" href="https://www.rodekho.in/service-areas" />
    </Helmet>
    <Header />
    <main className="pt-6">
      <ServiceAreas variant="page" />
    </main>
    <Footer />
  </div>
);

export default ServiceAreasPage;
